import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { t } = useTranslation();
  const location = useLocation();

  // On vérifie si on a les données nécessaires pour continuer
  const hasRequiredData = 
    location.state?.connector &&
    location.state?.evcpData;

  if (!hasRequiredData) {
    // Si rien n'est trouvé, on redirige vers une page d'erreur
    return <Navigate to="/error" replace state={{
      errorText: t("access_denied_no_session") 
    }} />;
  }

  return children;
};

export default ProtectedRoute;